import {
  AreaPoint,
  isSafeAreaPoint,
  isSafePoint,
  Point,
  SafeAreaPoint,
} from './types';

export function distributePoints(points: Point[]) {
  const safePoints: Map<
    number,
    {y: number[]; expressionValues?: Record<string, number[]>}
  > = new Map();

  points.forEach(p => {
    if (!isSafePoint(p)) {
      return;
    }

    const po = safePoints.get(p.x);
    if (po) {
      po.y.push(Number(p.y));
      Object.entries(p.expressionValues ?? {}).forEach(([key, value]) => {
        if (!po.expressionValues) {
          po.expressionValues = {};
        }
        if (!po.expressionValues![key]) {
          po.expressionValues![key] = [];
        }
        po.expressionValues![key].push(Number(value));
      });
    } else {
      safePoints.set(p.x, {
        y: [Number(p.y)],
        expressionValues: p.expressionValues
          ? Object.fromEntries(
              Object.entries(p.expressionValues).map(([key, value]) => [
                key,
                [Number(value)],
              ])
            )
          : undefined,
      });
    }
  });

  return Array.from(safePoints)
    .map(([x, b]) => ({x, y: b.y, expressionValues: b.expressionValues}))
    .sort((a, b) => a.x - b.x);
}

export function distributeAreaPoints(areaPoints: AreaPoint[]) {
  const points: Map<number, {min: number[]; max: number[]}> = new Map();

  areaPoints.forEach(p => {
    if (!isSafeAreaPoint(p)) {
      return;
    }

    const point = points.get(p.x);
    if (point) {
      point.min.push(p.y);
      point.max.push(p.y0);
    } else {
      points.set(p.x, {min: [p.y], max: [p.y0]});
    }
  });

  return Array.from(points)
    .reduce((acc, [i, p]) => {
      if (p) {
        acc.push({
          x: i,
          y: Math.min(...p.min),
          y0: Math.max(...p.max),
        });
      }
      return acc;
    }, [] as SafeAreaPoint[])
    .sort((a, b) => a.x - b.x);
}
